import { render, staticRenderFns } from "./CourseCatalog.vue?vue&type=template&id=17f2565d&scoped=true&"
import script from "./CourseCatalog.vue?vue&type=script&lang=js&"
export * from "./CourseCatalog.vue?vue&type=script&lang=js&"
import style0 from "./CourseCatalog.vue?vue&type=style&index=0&id=17f2565d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f2565d",
  null
  
)

export default component.exports